import styled from 'styled-components';
import React, { useState, useRef, forwardRef, useMemo } from 'react';
import { isBrowser, isMobile } from 'react-device-detect';
import ScaleLoader from 'react-spinners/ScaleLoader';
import images from '../../assets';
import colors from '../../libs/colors';
import { Button, Modal, Fade, FormGroup, FormControlLabel, Checkbox, InputBase } from '@material-ui/core';
import { HorizontalSp, VerticalSp, MediaQuery, ModalContents, ModalTitle, ModalNorBtn } from '../Common';
import { useTranslation } from 'react-i18next';
import Store from 'store';
import Ratio from 'react-ratio';
import { BlockReqBtn } from '../../components/guide/license';
import { getModalWidh } from '../../_utils/modalWidh';
import { getCurrentLang, getStringByLang } from '../../libs/lang';

export const JpDivStyle = styled.div`
  line-height: 1.35;
  word-break: normal;    
  overflow-wrap: anywhere;    
  white-space: normal;       
`;

export const InputGroup = styled.div`
  height: 52px;
  border-bottom: 1px solid #999999;
  position: relative;
`;

export const InputPad = styled.div`
  padding: 9px;
  display: flex;
  align-items: center;
`;

export const InputPlaceHolder = styled.div`
  position: absolute;
  left: 9px;
  top: 9px;
  height: 36px;
  z-index: -1;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #999999;
  font-family: 'NSCJKrR';
`;

export const BlockBoxV2StyleV2 = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  height: 70%;
  border: 1px solid #dddddd;
  margin: 10px;
  padding: 30px;
  background-color: #fafafa;
  cursor: pointer;

  .a {
    font-family: NSCJKrR;
    font-size: 25px;
    color: black;
    text-align: center;
    word-break: keep-all;
    font-weight: bold;
    color: #999;
  }

  .b {
    font-family: NSCJKrR;
    color: #999999;
    font-size: 13px;
    text-align: center;
  }

  .c {
    font-family: NSCJKrR;
    color: #999999;
    font-size: 13px;
    text-align: center;
  }
  .d {
    font-family: NSCJKrB;
    color: #999999;
    font-size: 18px;
    text-align: center;
    word-break: keep-all;
  }

  .od {
    font-family: NSCJKrB;
    color: #999999;
    font-size: 13px;
    text-align: center;
    word-break: keep-all;
  }

  &:hover {
    .a {
      color: #ff8a06;
    }
    .d {
      color: #ff8a06;
    }
  }
`;

export const BlockBoxV2Style = styled.div`
  @media screen and (min-width: 800px) {
     {
      display: flex;
      flex-direction: column;
      width: fit-content;
      height: 70%;
      border-radius: 5px;
      border: ${(props) =>
        !props.hovered && props.idx === props.selectIdx ? '1px solid #FF8A06' : '1px solid #dddddd'};
      margin: 10px;
      padding: 30px;
      background-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? 'white' : '#FAFAFA')};
      cursor: pointer;
    }
    .img_a {
      content: ${(props) =>
        !props.hovered && props.idx === props.selectIdx ? `url(${images.credit_active})` : `url(${images.credit_non})`};
      width: 20px;
      height: 20px;
    }

    .a {
      font-family: NSCJKrR;
      font-size: 38px;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '#999')};
      text-align: center;
      word-break: keep-all;
      font-weight: bold;
    }

    .b {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 13px;
      text-align: center;
    }

    .c {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 13px;
      text-align: center;
    }
    .d {
      font-family: NSCJKrB;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '#999')};
      font-size: 18px;
      text-align: center;
      word-break: keep-all;
    }
    .od {
      font-family: NSCJKrB;
      color: #999999;
      font-size: 11px;
      text-align: center;
      word-break: keep-all;
      text-decoration: line-through;
      height: 20px;
    }
    .odd {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 9px;
      text-align: center;
      word-break: keep-all;
      height: 20px;
    }

    .purchase {
      margin: auto;
      font-family: NSCJKrB;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FFFFFF' : '#999999')};
      background-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '')};
      border-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '')};
      font-size: 0.875rem;
      height: 30px;
      padding: 0px 15px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      border-style: solid;
      border-width: thin;
    }
    &:hover {
      background-color: white;
    }
  }

  @media (max-width: 799px) {
     {
      display: flex;
      flex-direction: column;
      width: 78%;
      height: 80%;
      border: ${(props) =>
        !props.hovered && props.idx === props.selectIdx ? '1px solid #FF8A06' : '1px solid #dddddd'};
      border-radius: 5px;
      margin: 10px;
      padding: 10px;
      background-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? 'white' : '#FAFAFA')};
      cursor: pointer;
    }

    .img_a {
      content: ${(props) =>
        !props.hovered && props.idx === props.selectIdx ? `url(${images.credit_active})` : `url(${images.credit_non})`};
      width: 15px;
      height: 15px;
    }

    .a {
      font-family: NSCJKrR;
      font-size: 38px;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '#999')};
      text-align: center;
      word-break: keep-all;
      font-weight: bold;
    }

    .b {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 13px;
      text-align: center;
    }

    .c {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 13px;
      text-align: center;
    }
    .d {
      font-family: NSCJKrB;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '#999')};
      font-size: 18px;
      text-align: center;
      word-break: keep-all;
    }
    .od {
      font-family: NSCJKrB;
      color: #999999;
      font-size: 11px;
      text-align: center;
      word-break: keep-all;
      text-decoration: line-through;
      height: 20px;
    }
    .odd {
      font-family: NSCJKrR;
      color: #999999;
      font-size: 9px;
      text-align: center;
      word-break: keep-all;
      height: 20px;
    }
    .purchase {
      margin: auto;
      font-family: NSCJKrR;
      color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FFFFFF' : '#999999')};
      background-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : '')};
      border-color: ${(props) => (!props.hovered && props.idx === props.selectIdx ? '#FF8A06' : 'gray')};
      font-size: 0.61rem;
      height: 30px;
      padding: 0px 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      border-width: thin;
      border-style: solid;
    }
  }

  &:hover {
    border-color: #ff8a06;
    background-color: white;
    .purchase {
      color: #ffffff;
      background-color: #ff8a06;
      border-color: #ff8a06;
    }
    .a {
      color: #ff8a06;
    }
    .d {
      color: #ff8a06;
    }

    .img_a {
      content: url(${images.credit_active});
    }
  }
`;

export const InActiveBtn = ({ aigenerate = false, onClick, children, style }) => {
  return (
    <>
      {aigenerate ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div
            onClick={onClick}
            style={{
              fontFamily: 'NSCJKrB',
              color: '#686868',
              fontSize: 14,
              height: 50,
              padding: '0px 20px',
              backgroundColor: 'white',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 5,
              border: '1px solid #D9D9D9',
              ...style,
            }}
          >
            {children}
          </div>
        </div>
      ) : (
        <div
          onClick={onClick}
          style={{
            fontFamily: 'NSCJKrB',

            height: 50,
            backgroundColor: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 8,
            border: '1px solid #D9D9D9',
            ...style,
          }}
        >
          {children}
        </div>
      )}
    </>
  );
};

export const ActiveBtn = ({ aigenerate = false, onClick, children, style }) => {
  return (
    <>
      {aigenerate ? (
        <div style={{ display: 'flex', justifyContent: 'center', width: '48%' }}>
          <div
            onClick={onClick}
            style={{
              fontFamily: 'NSCJKrB',
              color: 'white',
              fontSize: 18,
              height: 50,
              padding: '0px 20px',
              backgroundColor: '#fe8b07',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: 5,
              border: '1px solid #fe8b07',
              ...style,
            }}
          >
            {children}
          </div>
        </div>
      ) : (
        <div
          onClick={onClick}
          style={{
            fontFamily: 'NSCJKrB',
            color: 'white',
            fontSize: 18,
            height: 50,
            padding: '0px 20px',
            backgroundColor: '#fe8b07',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 5,
            border: '1px solid #fe8b07',
            ...style,
          }}
        >
          {children}
        </div>
      )}
    </>
  );
};

export const SendCompleteModal = ({ show, onClose, onConfirm, generate_step }) => {
  const { t } = useTranslation();
  return (
    <>
      <MediaQuery min={800}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ marginTop: 20, marginBottom: 10 }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 24 }}>
                    {t('ai_generate_modal_title')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 24 }} />

                  {Store.get('lang') === 'kr' ? (
                    <>
                      <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 17 }}>
                        {t('ai_generate_modal_content1')}
                      </div>
                      <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 17 }}>
                        <strong> {t('ai_generate_modal_content2')}</strong> {t('ai_generate_modal_content3')}{' '}
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 17 }}>
                        {t('ai_generate_modal_content1')}
                      </div>
                      <div
                        style={{
                          fontFamily: 'NSCJKrR',
                          color: 'black',
                          fontSize: 17,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        {t('ai_generate_modal_content3')}
                        <br></br>
                        <strong> {t('ai_generate_modal_content2')}</strong>
                      </div>
                    </div>
                  )}
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 40 }}>
                  <ModalNorBtn
                    onClick={onClose}
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#ff8a06',
                      borderStyle: 'solid',
                      borderColor: '#ff8a06',
                      borderWidth: 'thin',
                      width: '27%',
                      padding: '0px 5px',
                    }}
                  >
                    {t('go_back')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  <ModalNorBtn
                    onClick={onConfirm}
                    style={{ backgroundColor: '#ff8a06', width: '27%', padding: '0px 5px' }}
                  >
                    {t('go_result')}
                  </ModalNorBtn>
                </div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
      <MediaQuery min={400} max={799}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ marginTop: 20, marginBottom: 10 }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 20 }}>
                    {t('ai_generate_modal_title')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 18 }} />
                  <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 16 }}>
                    {t('ai_generate_modal_content1')}
                  </div>
                  {Store.get('lang') === 'kr' ? (
                    <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 16 }}>
                      <strong> {t('ai_generate_modal_content2')}</strong> {t('ai_generate_modal_content3')}{' '}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <div
                        style={{
                          fontFamily: 'NSCJKrR',
                          color: 'black',
                          fontSize: 16,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        {t('ai_generate_modal_content3')}
                        <br></br>
                        <strong> {t('ai_generate_modal_content2')}</strong>
                      </div>
                    </div>
                  )}
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 30 }}>
                  <ModalNorBtn
                    onClick={onClose}
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#ff8a06',
                      borderStyle: 'solid',
                      borderColor: '#ff8a06',
                      borderWidth: 'thin',
                      width: '35%',
                      padding: '0px 5px',
                      fontSize: 16,
                    }}
                  >
                    {t('go_back')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  <ModalNorBtn
                    onClick={onConfirm}
                    style={{ backgroundColor: '#ff8a06', width: '35%', padding: '0px 5px', fontSize: 16 }}
                  >
                    {t('go_result')}
                  </ModalNorBtn>
                </div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
      <MediaQuery max={399}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ marginTop: 18, marginBottom: 10 }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 18 }}>
                    {t('ai_generate_modal_title')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 16 }} />

                  <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 14 }}>
                    {t('ai_generate_modal_content1')}
                  </div>

                  {Store.get('lang') === 'kr' ? (
                    <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 14 }}>
                      <strong> {t('ai_generate_modal_content2')}</strong> {t('ai_generate_modal_content3')}{' '}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                      }}
                    >
                      <div
                        style={{
                          fontFamily: 'NSCJKrR',
                          color: 'black',
                          fontSize: 14,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        {t('ai_generate_modal_content3')}
                        <br></br>
                        <strong> {t('ai_generate_modal_content2')}</strong>
                      </div>
                    </div>
                  )}
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 30 }}>
                  <ModalNorBtn
                    onClick={onClose}
                    style={{
                      backgroundColor: '#ffffff',
                      color: '#ff8a06',
                      borderStyle: 'solid',
                      borderColor: '#ff8a06',
                      borderWidth: 'thin',
                      width: '35%',
                      padding: '0px 5px',
                      fontSize: 16,
                    }}
                  >
                    {t('go_back')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  <ModalNorBtn
                    onClick={onConfirm}
                    style={{ backgroundColor: '#ff8a06', width: '35%', padding: '0px 5px', fontSize: 16 }}
                  >
                    {t('go_result')}
                  </ModalNorBtn>
                </div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
    </>
  );
};

export const LoadingModal = ({ show }) => {
  return (
    <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={show}>
      <Fade in={show}>
        <div>
          <ScaleLoader color={'#fc8a06'} loading={true} size={300} />
        </div>
      </Fade>
    </Modal>
  );
};

export const TagGenerateDes = () => {
  const lang = getCurrentLang();
  const generateDesTexts = useMemo(
    () => ({
      kr: (
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 'clamp(1rem, 0.8214rem + 0.8929vw, 2.25rem)',
            padding: '0rem 0.25rem',
            color: 'black',
            textAlign: 'center',
          }}
        >
          인공지능 생성 AI가 귀하의 레퍼런스 이미지와 유사한
          <br />
          <span style={{ fontFamily: 'NSCJKrB' }}>텍스타일 디자인을 </span>
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>1분 만에 무제한 무료 생성</span>해 제작해드립니다.
        </div>
      ),
      en: (
        <div
          style={{
            fontFamily: 'NSCJKrB',
            fontSize: 'clamp(1rem, 0.8214rem + 0.8929vw, 2.25rem)',
            padding: '0rem 0.25rem',
            color: 'black',
            textAlign: 'center',
          }}
        >
          AI Generator can generate{' '}
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>unlimited textile designs</span> <br />
          similar to your reference image
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}> for free in just one minute.</span>
        </div>
      ),
      jp: (
        <div
          style={{
            fontFamily: 'NSCJKrB', 
            fontSize: 'clamp(1rem, 0.8214rem + 0.8929vw, 2.25rem)',
            color: 'black',
            textAlign: 'center',
          }}
        >
          AIジェネレーターが参考画像と類似した
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>無制限のテキスタイルデザイン</span>を <br />
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>わずか1分、無料で</span>生成します。
        </div>
      ),
    }),
    [],
  );
  const currentText = generateDesTexts[lang] || generateDesTexts['en'];

  return (
    <>
      <MediaQuery min={800}>{currentText}</MediaQuery>
      <MediaQuery max={799}>{currentText}</MediaQuery>
    </>
  );
};

export const TagGenerateDesV2 = () => {
  const contentByLang = {
    kr: {
      desktop: (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 36,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            1분 만에 나만의 디자인을 <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>무제한 무료 생성</span>{' '}
            해보세요!
          </div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 24,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
              padding: '10px',
            }}
          >
            <span style={{ fontFamily: 'NSCJKrB' }}>1분 만에 디자인을 무제한 무료 생성</span> 하고, 최초 제공되는{' '}
            <span style={{ fontFamily: 'NSCJKrB' }}>3크레딧</span>으로 원하는 디자인만 다운로드 하세요.
          </div>
        </>
      ),
      mobile: (
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 16,
            color: 'black',
            textAlign: 'center',
            wordBreak: 'keep-all',
          }}
        >
          인공지능 AI가 귀사의 <span style={{ fontFamily: 'NSCJKrB' }}>브랜드 이미지</span>에 맞는
          <br />
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>맞춤 텍스타일 디자인을 자동 생성</span>하여
          제작해드립니다.
        </div>
      ),
    },
    en: {
      desktop: (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 36,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            Generate <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>unlimited, free and personalized</span>{' '}
            designs in just one minute!
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              padding: '10px',
            }}
          >
            <span style={{ fontSize: 22, color: 'black' }}>
              Generate unlimited free designs in just one minute, and use the initial{' '}
              <span style={{ fontFamily: 'NSCJKrB' }}>3 free credits</span> to download the designs of your choice.
            </span>
          </div>
        </>
      ),
      mobile: (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 16,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            Generate <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>unlimited, free and personalized</span>{' '}
            designs in just one minute!
          </div>
          <div
            style={{
              marginTop: 12,
              fontSize: 14,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
              padding: '0 10px',
            }}
          >
            Generate unlimited free designs in a minute and use your first{' '}
            <span style={{ fontFamily: 'NSCJKrB' }}>3 free credits</span> for downloads.
          </div>
        </>
      ),
    },
    jp: {
      desktop: (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 36,
              color: 'black',
              textAlign: 'center',
              // wordBreak: 'keep-all',
            }}
          >
            わずか1分で、あなただけのデザインを
            <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB', }}>無料で無制限に </span>
            生成してみましょう！
          </div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 24,
              color: 'black',
              textAlign: 'center',
              // wordBreak: 'keep-all',
              padding: '10px',
            }}
          >
            <span style={{ fontFamily: 'NSCJKrB' }}>1分でデザインを無料で無制限に生成</span>し、最初に提供される
            <span style={{ fontFamily: 'NSCJKrB' }}>3ポイント</span>でお好みのデザインだけをダウンロードしてください。
          </div>
        </>
      ),
      mobile: (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 'clamp(0.5rem, 0.8rem + 0.8vw, 2rem)',
              color: 'black',
              textAlign: 'center',
              // wordBreak: 'keep-all',
            }}
          >
            わずか1分で、
            <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>あなただけのデザインを無料で無制限に</span>
            生成！
          </div>
          <div
            style={{
              marginTop: 12,
              fontSize: 'clamp(0.75rem, 0.6719rem + 0.25vw, 0.8125rem)',
              color: 'black',
              textAlign: 'center',
              // wordBreak: 'keep-all',
              padding: '0 10px',
            }}
          >
            1分で無料のデザインを無制限に生成し、最初の<span style={{ fontFamily: 'NSCJKrB' }}>無料3ポイント</span>
            でダウンロードできます。
          </div>
        </>
      ),
    },
  };

  const lang = Store.get('lang') || 'en';
  const currentContent = contentByLang[lang] || contentByLang.en;

  return (
    <>
      {/* PC 모드 */}
      <MediaQuery min={800}>{currentContent.desktop}</MediaQuery>

      {/* 모바일 모드 */}
      <MediaQuery max={799}>{currentContent.mobile}</MediaQuery>
    </>
  );
};

const TextBlock = ({ children, fontSize, paddingTop = 0 }) => (
  <div
    style={{
      fontFamily: 'NSCJKrR',
      fontSize,
      color: 'black',
      textAlign: 'center',
      wordBreak: 'keep-all',
      paddingTop,
    }}
  >
    {children}
  </div>
);

export const TagFeeDes = () => {
  const lang = getCurrentLang();
  const texts = {
    kr: {
      main: (
        <>
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>1분 만에</span> 디자인을&nbsp;
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>무제한 무료 생성</span>하고&nbsp;
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>필요한 디자인</span>만&nbsp;
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>다운로드</span>하세요!
        </>
      ),
      sub: (
        <>
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>최초 3회 무료 다운로드 </span>
          가능합니다.
        </>
      ),
      subMobile: (
        <>
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>최초 무료 제공 3크레딧</span>
          으로 원하는 디자인을 다운로드 하세요!
        </>
      ),
    },
    en: {
      main: (
        <>
          Create unlimited{' '}
          <span style={{ fontFamily: 'NSCJKrB', color: '#ff8a06' }}>free designs in just 1 minute</span>
          <br />
          and download for the designs you need.
        </>
      ),
      sub: (
        <>
          You can download up to{' '}
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>3 times for free initially.</span>
        </>
      ),
      subMobile: (
        <>
          Download the design of your choice with{' '}
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>the initial 3 credits provided for free!</span>
        </>
      ),
    },
    jp: {
      main: (
        <JpDivStyle>
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06'}}>1分で</span> デザインを
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06'}}>無制限に無料生成</span>して
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06'}}>必要なデザイン</span>だけ
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06'}}>ダウンロード</span>しましょう！
        </JpDivStyle>
      ),
      sub: (
        <>
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>初回は3回まで無料ダウンロード</span>
          が可能です。
        </>
      ),
      subMobile: (
        <>
          <span style={{ color: '#ff8a06', fontFamily: 'NSCJKrB' }}>初回無料3ポイント</span>
          でお好きなデザインをダウンロード！
        </>
      ),
    },
  };

  const t = texts[lang] || texts.en;
  return (
    <>
      {/* PC */}
      <MediaQuery min={800}>
        <TextBlock fontSize={'1.75rem'}>{t.main}</TextBlock>
        <TextBlock fontSize={'1.5rem'} paddingTop={15}>
          {t.sub}
        </TextBlock>
      </MediaQuery>

      {/* Mobile */}
      <MediaQuery max={799}>
        <MediaQuery min={421} max={799}>
          <TextBlock fontSize={'.8125rem'}>{t.main}</TextBlock>
          <VerticalSp sp={'3vw'} style={{ maxHeight: 10, minHeight: 10 }} />
          <TextBlock fontSize={'.75rem'}>{t.subMobile}</TextBlock>
        </MediaQuery>
        <MediaQuery max={420}>
          <TextBlock fontSize={'.75rem'}>{t.main}</TextBlock>
          <VerticalSp sp={'3vw'} style={{ maxHeight: 10, minHeight: 10 }} />
          <TextBlock fontSize={'.75rem'}>{t.subMobile}</TextBlock>
        </MediaQuery>
      </MediaQuery>
    </>
  );
};

//지역, 또는 언어가 한국이 아닌 경우, 크레딧 묶음 결제 할 때, 카드와 페이팔 결제 선택할 수 있도록 창 띄우기
// 한국 결제는 카드만 가능합니다. 페이팔 안됩니다. 사실상, 한국에서는 결제 방법 선택하는 모달창 없이 바로 엑심페이로 넘어갑니다. 2024.02.01
export const ChooseCardOrPayparModal = ({ show, onClose, onSelFst, onSelSnd }) => {
  const { t } = useTranslation();
  return (
    <>
      <MediaQuery min={800}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ margin: '20px 0px' }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 24 }}>
                    {t('choose_pay_method_title')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 40, minHeight: 24 }} />
                  <div style={{ fontFamily: 'NSCJKrR', color: 'black', fontSize: 15 }}>
                    {Store.get('lang') === 'kr' ? (
                      <strong> {t('choose_pay_method_desc')}</strong>
                    ) : (
                      <>
                        Please select a payment method between <strong>CARD</strong> and <strong>PAYPAL</strong>.
                      </>
                    )}
                  </div>
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
                  <ModalNorBtn paymethod={true} onClick={onSelFst} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('card')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  {Store.get('lang') === 'kr' ? (
                    ''
                  ) : (
                    <ModalNorBtn paymethod={true} onClick={onSelSnd} style={{ width: '27%', padding: '0px 5px' }}>
                      {t('paypal')}
                    </ModalNorBtn>
                  )}
                </div>
                <div class="portone-ui-container" data-portone-ui-type="paypal-rt"></div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
      <MediaQuery max={799}>
        <Modal style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }} open={show}>
          <Fade in={show}>
            <ModalContents style={{ width: getModalWidh() }} onClose={onClose}>
              <>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    paddingTop: 5,
                  }}
                >
                  <img alt="" src={images.icon_check_circle} style={{ margin: '20px 0px' }} />
                  <div style={{ fontFamily: 'NSCJKrB', color: 'black', fontSize: 20 }}>
                    {t('choose_pay_method_title')}
                  </div>
                  <VerticalSp sp={'1vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      fontFamily: 'NSCJKrR',
                      color: 'black',
                      fontSize: 15,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {Store.get('lang') === 'kr' ? (
                      <strong> {t('choose_pay_method_desc')}</strong>
                    ) : (
                      <div style={{ textAlign: 'center' }}>
                        Please select a payment method between <strong>CARD</strong> or <strong>PAYPAL</strong>.
                      </div>
                    )}
                  </div>
                </div>
                <VerticalSp sp={'3vw'} style={{ maxHeight: 54, minHeight: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <ModalNorBtn paymethod={true} onClick={onSelFst} style={{ width: '27%', padding: '0px 5px' }}>
                    {t('card')}
                  </ModalNorBtn>
                  <HorizontalSp sp={10} />
                  {Store.get('lang') === 'kr' ? (
                    ''
                  ) : (
                    <ModalNorBtn paymethod={true} onClick={onSelSnd} style={{ width: '27%', padding: '0px 5px' }}>
                      {t('paypal')}
                    </ModalNorBtn>
                  )}
                </div>
              </>
            </ModalContents>
          </Fade>
        </Modal>
      </MediaQuery>
    </>
  );
};

const WrapStart = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

export const WrapAuto = ({ children, ...props }) => {
  return <WrapStart {...props}>{children}</WrapStart>;
};

export const BlockSection = ({ children }) => {
  return <div style={{ width: 'fit-content', height: '100%' }}>{children}</div>;
};

export const BlockSectionV2 = ({ children }) => {
  return <div style={{ width: '100%', height: '100%' }}>{children}</div>;
};
export const BlockTag = ({ children, style }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        fontSize: '1.875rem',
        color: '#ff8a06',
        fontFamily: 'NSCJKrB',
        paddingBottom: 10,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
export const BlockTagV2 = ({ children, style }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        fontSize: 30,
        color: '#ff8a06',
        fontFamily: 'NSCJKrB',
        paddingBottom: 10,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const BlockTagV3 = ({ children, style }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        fontSize: 'clamp(0.75rem, calc(0.13vw + 0.72rem), 0.88rem)',
        color: '#000000',
        fontFamily: 'NSCJKrR',
        fontWeight: 'normal',
        paddingBottom: 10,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const BlockBox = ({ children, onClick, cursor }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        height: '100%',
        borderRadius: 5,
        border: '1px solid #dddddd',
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export const BlockBoxV2 = ({ firstHover, idx, selectIdx, children }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <BlockBoxV2Style hovered={firstHover} idx={idx} selectIdx={selectIdx}>
      {children}
    </BlockBoxV2Style>
  );
};

export const BlockHead = ({ bgcolor, blocktitle, inftext }) => {
  return (
    <div
      style={{
        backgroundColor: bgcolor,
        height: 120,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <div style={{ fontFamily: 'NSCJKrB', fontSize: 36, color: 'white' }}>{blocktitle}</div>
      <div style={{ fontFamily: 'NSCJKrR', fontSize: 20, color: 'white' }}>{inftext}</div>
    </div>
  );
};

export const BlockContents = ({ children }) => {
  return (
    <>
      <MediaQuery min={800}>
        <div
          style={{
            width: 'fit-content',
            height: 178,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 30,
            paddingBottom: 30,
          }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={799}>
        <div
          style={{
            width: 'fit-content',
            height: 'fit-content',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: 20,
            paddingBottom: 20,
          }}
        >
          {children}
        </div>
      </MediaQuery>
    </>
  );
};

export const BlockColum = ({ children, style }) => {
  return (
    <div
      style={{
        width: '100%',
        height: 178,
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
        alignItems: 'center',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export const BlockRow = ({ label, value }) => {
  return (
    <div style={{ display: 'flex', width: 311, justifyContent: 'space-evenly' }}>
      <div style={{ display: 'flex', width: 80 }}>
        <div style={{ fontFamily: 'NSCJKrR', fontSize: 24, color: '#999999', width: 80 }}>{label}</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', width: 80 }}>
        <div style={{ fontFamily: 'NSCJKrM', fontSize: 24, color: 'black' }}>{value}</div>
      </div>
    </div>
  );
};

export const BlockRowWithComment = ({ label, value, comment }) => {
  return (
    <div style={{ display: 'flex', width: 311, justifyContent: 'center', paddingRight: 40 }}>
      <div style={{ display: 'flex', width: 80 }}>
        <div style={{ fontFamily: 'NSCJKrR', fontSize: 24, color: '#999999', width: 80 }}>{label}</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', width: 80, paddingLeft: 20 }}>
        {Store.get('lang') === 'kr' ? (
          <div style={{ fontFamily: 'NSCJKrM', fontSize: 24, color: 'black' }}>
            {value}
            <span style={{ fontSize: 18 }}>(월)</span>
          </div>
        ) : (
          <div style={{ fontFamily: 'NSCJKrM', fontSize: 24, color: 'black' }}>
            {value}
            <span style={{ fontSize: 18 }}>(Month)</span>
          </div>
        )}
        <div style={{ fontFamily: 'NSCJKrM', fontSize: 12, color: 'green', whiteSpace: 'nowrap' }}>{comment}</div>
      </div>
    </div>
  );
};

export const BlockCreditRow = ({ label, value, comment }) => {
  return (
    <div style={{ display: 'flex', width: 311, paddingLeft: 10 }}>
      <div
        style={{ display: 'flex', flexDirection: 'column', width: 80, justifyContent: 'center', textAlign: 'center' }}
      >
        <div style={{ fontFamily: 'NSCJKrB', fontSize: 20, color: '#black', width: 80 }}>{label}</div>
        {Store.get('lang') === 'kr' ? (
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 13, color: '#999999', width: 80 }}>{`크레딧`}</div>
        ) : (
          <div style={{ fontFamily: 'NSCJKrR', fontSize: 13, color: '#999999', width: 80 }}>{`credit`}</div>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', width: 80 }}>
        <div style={{ fontFamily: 'NSCJKrM', fontSize: 24, color: 'black' }}>{value}</div>
        <div style={{ fontFamily: 'NSCJKrM', fontSize: 12, color: 'green', whiteSpace: 'nowrap' }}>{comment}</div>
      </div>
    </div>
  );
};

export const TagFeeCreditDes = forwardRef(
  ({ key, idx, credit, originCreditPayVal, creditPayVal, onClick, hoverEventFuntion }, ref) => {
    const { t } = useTranslation();
    const [hovered, setHovered] = useState(false);
    return (
      <>
        <MediaQuery min={800}>
          <div
          // onMouseEnter={() => hoverEventFuntion()}
          // onMouseLeave={() => hoverEventFuntion()}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 6,
              }}
            >
              <img class="img_a" style={{ marginRight: 5 }} />
              <div class="a" style={{ marginRight: 15 }}>
                {credit}
              </div>
            </div>
            <HorizontalSp sp={40} style={{ width: 70, height: 1, margin: 'auto', backgroundColor: '#aaaaaa' }} />

            <br />

            <div>
              {originCreditPayVal !== '' ? (
                <div class="od">{originCreditPayVal}</div>
              ) : (
                <div class="odd"> {t('credit_fee_desc1')}</div>
              )}
            </div>
            <div class="d">{creditPayVal}</div>

            <br />
            <div class="purchase" onClick={onClick}>
              {' '}
              {t('purchase')}{' '}
            </div>
          </div>
        </MediaQuery>
        <MediaQuery max={799}>
          <div
            onMouseEnter={() => {
              setHovered(true); // Set the state to true on mouse enter
            }}
            onMouseLeave={() => {
              setHovered(false); // Set the state to false on mouse leave
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 6,
              }}
            >
              <img class="img_a" style={{ marginRight: 5 }} />
              <div class="a" style={{ marginRight: 10 }}>
                {credit}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <HorizontalSp sp={40} style={{ width: 60, height: 1, backgroundColor: '#aaaaaa' }} />
            </div>

            <br />

            <div class="d">{creditPayVal}</div>
            <div style={{ marginBottom: 10 }}>
              {originCreditPayVal !== '' ? (
                <div class="od">{originCreditPayVal}</div>
              ) : (
                <div class="odd"> {t('credit_fee_desc1')}</div>
              )}
            </div>
            <div onClick={onClick} class="purchase" style={{ marginBottom: 10 }}>
              <p style={{ fontWeight: 'bold' }}>{t('purchase')}</p>
            </div>
          </div>
        </MediaQuery>
      </>
    );
  },
);

export const TagFeeSubCreditDes = forwardRef(
  ({ key, idx, credit, originCreditPayVal, creditPayVal, onClick, hoverEventFuntion }, ref) => {
    const { t } = useTranslation();
    const [hovered, setHovered] = useState(false);
    return (
      <>
        <MediaQuery min={800}>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 6,
              }}
            >
              {/* <img class='img_a' style={{marginRight:5, paddingTop: 5}}/> */}
              <div class="a" style={{ display: 'flex', marginRight: 10 }}>
                {credit}
                <div style={{ fontSize: '.75rem', paddingTop: 30 }}>{getStringByLang('회/월', '/mo', '回/月')}</div>
              </div>
            </div>
            <HorizontalSp sp={40} style={{ width: 70, height: 1, margin: 'auto', backgroundColor: '#aaaaaa' }} />

            <br />

            <div class="od" style={{ display: 'flex', justifyContent: 'center' }}>
              {originCreditPayVal}
              <div style={{ fontSize: '.625rem', paddingTop: 1 }}>{getStringByLang('/월', '/mo', '/月')}</div>
            </div>

            <div class="d" style={{ display: 'flex', justifyContent: 'center' }}>
              {creditPayVal}
              <div style={{ fontSize: '.625rem', paddingTop: 8 }}>{getStringByLang('/월', '/mo', '/月')}</div>
            </div>

            <br />
            <div class="purchase" onClick={onClick}>
              {t('purchase')}
            </div>
          </div>
        </MediaQuery>
        <MediaQuery max={799}>
          <div
            onMouseEnter={() => {
              setHovered(true); // Set the state to true on mouse enter
            }}
            onMouseLeave={() => {
              setHovered(false); // Set the state to false on mouse leave
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 6,
              }}
            >
              <img class="img_a" style={{ marginRight: 5 }} />
              <div class="a" style={{ marginRight: 10 }}>
                {credit}
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <HorizontalSp sp={40} style={{ width: 60, height: 1, backgroundColor: '#aaaaaa' }} />
            </div>

            <br />

            <div class="d" style={{ display: 'flex', justifyContent: 'center' }}>
              {creditPayVal}
              <div style={{ fontSize: 10, paddingTop: 8 }}>/{Store.get('lang') === 'kr' ? '월' : 'mo'}</div>
            </div>

            <div class="od" style={{ display: 'flex', justifyContent: 'center' }}>
              {originCreditPayVal}
              <div style={{ fontSize: 10, paddingTop: 1 }}>/{Store.get('lang') === 'kr' ? '월' : 'mo'}</div>
            </div>
            <div onClick={onClick} class="purchase" style={{ marginBottom: 10 }}>
              <p style={{ fontWeight: 'bold' }}>{t('purchase')}</p>
            </div>
          </div>
        </MediaQuery>
      </>
    );
  },
);

export const TagFeeOnceDes = () => {
  return (
    <>
      {/* <MediaQuery min = {800}> */}
      {Store.get('lang') === 'kr' ? (
        <>
          <br></br>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={images.generate_fee_once} />
          </div>
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 30,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
              fontWeight: 'bold',
            }}
          >
            단건 결제
          </div>
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 13,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            디자인 파일 유형 : 포토샵 PSD+JPG 포함
          </div>{' '}
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 20,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            <span style={{ color: '#999999' }}> 디자인 1개 구매시</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong> ₩50,000 </strong>
          </div>
        </>
      ) : (
        <>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <img src={images.generate_fee_once} />
          </div>
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrB',
              fontSize: 30,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
              fontWeight: 'bold',
            }}
          >
            Single Purchase
          </div>
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 13,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            Design File Types : Included PSD+JPG
          </div>{' '}
          <br />
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 20,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            <span style={{ color: '#999999' }}> Purchasing a single design</span> &nbsp;&nbsp;&nbsp;&nbsp;
            <strong>$40</strong>
          </div>
        </>
      )}
      {/* </MediaQuery> */}
    </>
  );
};
export const TagFeeCompanyNDes = ({ onClick }) => {
  const { t } = useTranslation();
  const lang = getCurrentLang();

  const texts = {
    kr: {
      title: '기업에서 도입을 검토하고 계신가요?',
      desc: (
        <>
          {t('generate_fee_company_desc1')}{' '}
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>{t('generate_fee_company_desc2')}</span>
          {t('generate_fee_company_desc3')}
        </>
      ),
      notice: <span style={{ color: '#FF8A06' }}> {t('generate_fee_company_desc4')} </span>,
      button: t('estimate_request'),
      buttonPadding: { paddingLeft: 30, paddingRight: 30 },
    },
    en: {
      title: 'Corporate Purchase',
      desc: (
        <>
          We provide
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>&nbsp;customized quotes for businesses </span>
          requiring a large amount of credits.
        </>
      ),
      notice: (
        <span style={{ color: '#FF8A06' }}>
          *For corporate payments, please contact customer service for your inquiries.
        </span>
      ),
      button: t('contact_us'),
      buttonPadding: { paddingLeft: 60, paddingRight: 60 },
    },
    jp: {
      title: '法人でのご利用をご検討中ですか？',
      desc: (
        <>
          {t('generate_fee_company_desc1')}
          <span style={{ fontFamily: 'NSCJKrB', color: '#FF8A06' }}>{t('generate_fee_company_desc2')}</span>
          {t('generate_fee_company_desc3')}
        </>
      ),
      notice: (
        <span style={{ color: '#FF8A06' }}>
          *導入に関するお問い合わせをいただければ、迅速にご連絡いたします。
        </span>
      ),
      button: t('contact_us'),
      buttonPadding: { paddingLeft: 60, paddingRight: 60 },
    },
  };

  const c = texts[lang] || texts.en;

  const renderContent = (isMobile) => (
    <>
      {!isMobile && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img src={images.generate_fee_company} />
        </div>
      )}
      <br />
      <div
        style={{
          fontFamily: 'NSCJKrB',
          fontSize: isMobile ? '1.25rem' : '1.875rem',
          color: 'black',
          textAlign: 'center',

          fontWeight: 'bold',
        }}
      >
        {c.title}
      </div>
      <br />
      <div
        style={{
          fontFamily: 'NSCJKrR',
          fontSize: isMobile ? '1.125rem' : '1.25rem',
          color: 'black',
          textAlign: 'center',
        }}
      >
        {c.desc}
      </div>
      <br />
      <div
        style={{
          fontFamily: 'NSCJKrR',
          fontSize: '.8125rem',
          color: 'black',
          textAlign: 'center',
        }}
      >
        {c.notice}
      </div>
      <VerticalSp sp={isMobile ? '2.4vw' : '1.5vw'} style={{ minHeight: isMobile ? 30 : 15 }} />
      <BlockReqBtn style={c.buttonPadding} onClick={onClick}>
        {c.button}
      </BlockReqBtn>
      <VerticalSp sp={isMobile ? '10vw' : '7.4vw'} style={{ minHeight: isMobile ? 70 : 30 }} />
    </>
  );

  return (
    <>
      {/* PC */}
      <MediaQuery min={801}>{renderContent(false)}</MediaQuery>

      {/* Mobile */}
      <MediaQuery max={800}>
        <VerticalSp sp={'2.4vw'} style={{ minHeight: 50 }} />
        {renderContent(true)}
      </MediaQuery>
    </>
  );
};

export const TagFeeCompanyDes = () => {
  return (
    <>
      {/* <MediaQuery min={800}> */}
      {Store.get('lang') === 'kr' ? (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 36,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            많은 크레딧이 필요한 기업을 위해 <span style={{ fontFamily: 'NSCJKrB' }}>기업별 맞춤 견적</span>을
            제공해드려요.
          </div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 20,
              color: '#ff8a06',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            *기업 결제는 고객센터로 문의 부탁드립니다.
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 32,
              color: 'black',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            For companies that need more credit,
            <br />
            we provide
            <span style={{ fontFamily: 'NSCJKrB' }}>
              &nbsp;customized quotes to meet the company's individual needs.
            </span>
          </div>
          <div
            style={{
              fontFamily: 'NSCJKrR',
              fontSize: 18,
              color: '#ff8a06',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            *For corporate payments, please contact customer service for your inquiries.
          </div>
        </>
      )}
      {/* </MediaQuery> */}
      {/* <MediaQuery max={799}>
        {Store.get('lang') === 'kr' ? (
            <>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 18,
                  color: 'black',
                  textAlign: 'center',
                  wordBreak: 'keep-all',
                }}
              >
                많은 크레딧이 필요한 기업을 위해 <span style={{ fontFamily: 'NSCJKrB', }}>기업별 맞춤 견적</span>을 제공해드려요.
              </div>
              <div 
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 10,
                color: '#ff8a06',
                textAlign: 'center',
                wordBreak: 'keep-all',
              }}>
                *기업 결제는 고객센터로 문의 부탁드립니다.
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  fontFamily: 'NSCJKrR',
                  fontSize: 16,
                  color: 'black',
                  textAlign: 'center',
                  wordBreak: 'keep-all',
                }}
              >
              For companies that need more credit,<br /> 
              we provide <span style={{ fontFamily: 'NSCJKrB', }}>customized quotes to meet the company's individual needs.</span>
              </div>
              <div 
              style={{
                fontFamily: 'NSCJKrR',
                fontSize: 9,
                color: '#ff8a06',
                textAlign: 'center',
                wordBreak: 'keep-all',
              }}>
                *For corporate payments, please contact customer service for your inquiries.
              </div>
            </>
          )}
      </MediaQuery> */}
    </>
  );
};
